export default __webpack_public_path__ + "static/media/24.62cd8856.jpg";